import {orangeColors} from '../../../../../layouts/theme/designSystem';

/** Prototype `.section-card` — shared card shell for tray and grid */
export const profileComparisonSectionCardSx = {
  border: '0.5px solid',
  borderColor: 'divider',
  borderRadius: '14px',
  px: 2.5,
  py: 2.25,
  mb: 2,
} as const;

/** Prototype `.section-title` — in-card panel headers */
export const profileComparisonSectionTitleSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  fontSize: '13px',
  fontWeight: 600,
  color: 'text.primary',
  mb: 1.25,
} as const;

/** Prototype `.page-title` — major section heading above compare blocks */
export const profileComparisonSectionHeadingSx = {
  fontSize: '22px',
  fontWeight: 600,
  letterSpacing: '-0.4px',
  lineHeight: 1.3,
  color: 'text.primary',
  mb: 0.375,
} as const;

/** Prototype `.page-sub` */
export const profileComparisonSectionSubtitleSx = {
  fontSize: '13px',
  color: 'text.secondary',
  lineHeight: 1.5,
  mb: 2,
} as const;

/** Prototype `.cmp-tray-slot` base */
export const profileComparisonTraySlotSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.875,
  px: 1.5,
  py: 0.75,
  borderRadius: '8px',
  fontSize: '12.5px',
  fontWeight: 500,
  minWidth: 140,
  whiteSpace: 'nowrap',
  transition: 'all 0.15s',
} as const;

/** Prototype `.cmp-tray-empty` */
export const profileComparisonTrayEmptySx = {
  ...profileComparisonTraySlotSx,
  border: '1.5px dashed',
  borderColor: 'text.disabled',
  color: 'text.secondary',
  bgcolor: 'transparent',
} as const;

/** Prototype `.cmp-card` default */
export const profileComparisonCardBaseSx = {
  p: '10px 12px',
  borderRadius: '8px',
  border: '1.5px solid',
  borderColor: 'divider',
  bgcolor: 'background.paper',
  cursor: 'pointer',
  userSelect: 'none',
  transition: 'all 0.15s',
  '&:hover': {
    borderColor: 'text.disabled',
    bgcolor: orangeColors[5],
  },
} as const;

/** Prototype `#cmp-overflow-msg` */
export const profileComparisonOverflowSx = {
  mt: 1.5,
  display: 'flex',
  alignItems: 'flex-start',
  gap: 0.75,
  px: 1.25,
  py: 1,
  borderRadius: '6px',
  fontSize: '12px',
  color: 'text.secondary',
  bgcolor: orangeColors[5],
  border: '0.5px solid',
  borderColor: 'divider',
} as const;

/** Prototype `.cmp-result-section` container */
export const profileComparisonResultSectionSx = {
  mt: 2.5,
  pt: 2.5,
  borderTop: '0.5px solid',
  borderColor: 'divider',
} as const;

export const profileComparisonResultCalloutSx = {
  display: 'flex',
  gap: 1.5,
  alignItems: 'flex-start',
  py: 1.5,
  px: 2,
  borderRadius: '10px',
  mb: 2,
} as const;

export const profileComparisonResultScoreCardsSx = {
  display: 'grid',
  gridTemplateColumns: {xs: '1fr', md: '1fr 1fr'},
  gap: 1.5,
  mb: 2,
} as const;

export const profileComparisonResultGapGridSx = {
  display: 'grid',
  gridTemplateColumns: {xs: '1fr', md: 'repeat(3, 1fr)'},
  gap: 1.5,
  mb: 2,
} as const;

export const profileComparisonResultEffortGridSx = {
  display: 'grid',
  gridTemplateColumns: {xs: '1fr', md: '1fr 1fr'},
  gap: 1.5,
} as const;
